/**
 * @(#)2019/6/10.
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import Baiscs from "../Basics";
import ReactDOM from "react-dom";
import React, { isValidElement } from "react";
import { YxComponent, Connection } from "../../YxComponent";
import { yxTextStrProps } from "../../../utils";

//默认props
let defaul = () => {
  return {
    isReplace: false, //是否开启替换
    replaceLength: 4, //替换长度
    replaceType: "center", //替换方式，左边，右边，中间  left、center、right
    replaceAppointStr: "", //指定替换某特定字符,如指定后，length和type将失效
    replaceStr: "*", //替代符号
    replaceStrLength: null, //替代符号长度，、、
  };
};
/*
 * String，展示字符串的组件
 * @param children {string} 子节点，需要展示的内容
 * @param isReplace {bool} 是否开启替换功能，默认false
 * @param replaceType {enum} center left right 脱敏的方式,默认中间， 左边，右边，中间
 * @param replaceLength {Number} 需要替换的长度， 默认为0，则不进行任何处理
 * @param replaceAppointStr {String} 指定替换某特定字符,如指定后，length和type将失效
 * @param replaceStr {String} 替代符号
 * @param replaceStrLength {Number},//替代符号长度，默认替换掉多少字符，就添加多少替代符号
 * */

@Connection(defaul)
export default class String extends YxComponent {
  //默认参数
  static defaultProps = {
    children: "", //子节点
  };

  constructor(props) {
    super(props);
    this.state = {};
    this.divClassName = ["yx_text_string"];
  }

  //在渲染前调用
  componentWillMount() {}

  componentDidMount() {}

  //外部更改了props的值，视图更新的时候会调用这个函数
  componentWillUpdate(nextProps) {}

  //卸载时
  componentWillUnmount() {}

  //处理字符串
  Handle(tmpProps) {
    try {
      let str = tmpProps.children;
      let rlen = !tmpProps.replaceStrLength
        ? tmpProps.replaceLength
        : tmpProps.replaceStrLength;
      //输出足够数量的替换字符
      let replaceStr = function () {
        let rstr = "";
        for (let i = 0; i < rlen; i++) {
          rstr += tmpProps.replaceStr;
        }
        return rstr;
      };

      if (str == null) return "";

      str = str + ""; //强制转为字符串
      if (tmpProps.isReplace) {
        if (tmpProps.replaceAppointStr) {
          str = str.replace(
            new RegExp(tmpProps.replaceAppointStr, "g"),
            tmpProps.replaceStr
          );
        } else {
          //原始字符长度大于替换长度
          if (
            tmpProps.replaceLength > 0 &&
            str.length > tmpProps.replaceLength
          ) {
            //如果是对右边进行字符替换
            if (tmpProps.replaceType == "left") {
              str = str.substring(tmpProps.replaceLength, str.length);
              str = replaceStr() + str;
            } else if (tmpProps.replaceType == "right") {
              str = str.substring(0, str.length - tmpProps.replaceLength);
              str = str + replaceStr();
            } else {
              let strLeft = ""; //左边部分字符串
              let strRight = ""; //右边部分字符串
              let plength =
                (tmpProps.replaceLength % 2
                  ? tmpProps.replaceLength - 1
                  : tmpProps.replaceLength) / 2; //长度必须为偶数
              let strLength = str.length / 2;
              if (str.length % 2 == 0) strLength = (str.length + 1) / 2;
              strLeft = str.substring(0, strLength - plength);
              strRight = str.substring(strLength + plength, str.length);
              str = strLeft + replaceStr() + strRight;
            }
          }
        }
      }
      return { ...tmpProps, children: str };
    } catch (e) {
      console.log(e);
    }
  }

  renderHtml = (tmpProps) => {
    let childrenType = typeof tmpProps.children;
    let html = "";
    tmpProps = { ...tmpProps, className: this.parentClass };
    if (childrenType == "string" || childrenType == "number") {
      tmpProps = this.Handle(tmpProps);
    } else if (
      Object.prototype.toString.call(tmpProps.children) === "[object Array]"
    ) {
      return tmpProps.children.map((val, index) => {
        return this.renderHtml({
          key: index,
          ...tmpProps,
          children: val.children || val,
        });
      });
    }
    if (
      isValidElement(tmpProps.children) ||
      childrenType == "string" ||
      childrenType == "number"
    ) {
      html = Baiscs.html(yxTextStrProps(tmpProps));
    }
    return html;
  };

  render() {
    let tmpProps = { ...this.props };
    return this.renderHtml(tmpProps);
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/String/String.js